import { Controller } from "@hotwired/stimulus"
import { flagCommentedNeighbours } from "../utils/review_neighbours"

export default class extends Controller {
  static targets = ["slide", "previousButton", "nextButton", "counter"]
  static values = { index: Number }

  connect() {
    this.indexValue = this.normalizedIndex(this.hasIndexValue ? this.indexValue : 0)
    this.render()
  }

  previous(event) {
    event?.preventDefault()
    this.indexValue = this.normalizedIndex(this.indexValue - 1)
    this.render()
  }

  next(event) {
    event?.preventDefault()
    this.indexValue = this.normalizedIndex(this.indexValue + 1)
    this.render()
  }

  keydown(event) {
    if (event.key === "ArrowLeft") {
      this.previous(event)
    } else if (event.key === "ArrowRight") {
      this.next(event)
    }
  }

  refresh() {
    this.indexValue = this.normalizedIndex(this.indexValue)
    this.render()
  }

  // A review deep link can land on a comment left on a slide other than the one
  // showing — the review canvas asks for it to be shown before scrolling to it.
  revealSlide(event) {
    const index = this.slideTargets.findIndex((slide) => slide.contains(event.target))
    if (index < 0) return

    this.indexValue = index
    this.render()
  }

  flagCommentedNeighbours() {
    flagCommentedNeighbours({
      parts: this.slideTargets,
      currentIndex: this.normalizedIndex(this.indexValue),
      previousButton: this.hasPreviousButtonTarget ? this.previousButtonTarget : null,
      nextButton: this.hasNextButtonTarget ? this.nextButtonTarget : null
    })
  }

  render() {
    const count = this.slideTargets.length
    const activeIndex = this.normalizedIndex(this.indexValue)

    this.slideTargets.forEach((slide, index) => {
      const active = index === activeIndex
      slide.hidden = !active
      slide.classList.toggle("is-active", active)
    })

    if (this.hasPreviousButtonTarget) this.previousButtonTarget.disabled = count <= 1
    if (this.hasNextButtonTarget) this.nextButtonTarget.disabled = count <= 1
    if (this.hasCounterTarget) this.counterTarget.textContent = count > 0 ? `${activeIndex + 1} / ${count}` : "0 / 0"
    this.flagCommentedNeighbours()
  }

  normalizedIndex(index) {
    const count = this.slideTargets.length
    if (count === 0) return 0

    return ((Number(index) || 0) + count) % count
  }
}
